module.exports = __webpack_public_path__ + "fonts/Lato-Medium.4846ef7.eot";